import {Component, OnInit} from '@angular/core';
import {Player, Strength} from "../../model/player";
import {PlayerService} from "../../service/player.service";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatIcon} from "@angular/material/icon";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {MatCard, MatCardActions, MatCardContent} from "@angular/material/card";
import {MatOption, MatSelect} from "@angular/material/select";
import {KeyValuePipe} from "@angular/common";
import {MatAnchor, MatButton} from "@angular/material/button";
import {MatSnackBar} from "@angular/material/snack-bar";
import {NgxMaskDirective} from "ngx-mask";

@Component({
  selector: 'app-player-edit',
  imports: [
    FormsModule,
    RouterLink,
    MatFormField,
    MatInput,
    MatIcon,
    MatHint,
    MatLabel,
    MatRadioGroup,
    MatRadioButton,
    MatCard,
    MatCardContent,
    MatCardActions,
    MatSelect,
    MatOption,
    KeyValuePipe,
    MatButton,
    MatAnchor,
    ReactiveFormsModule,
    NgxMaskDirective
  ],
  templateUrl: './player-edit.component.html',
  standalone: true,
  styleUrl: './player-edit.component.scss'
})
export class PlayerEditComponent implements OnInit {
  player: Player;
  isEditMode: boolean = false;

  constructor(
    private playerService: PlayerService,
    private route: ActivatedRoute,
    private router: Router,
    private _snackBar: MatSnackBar,
  ) {
    this.player = new Player();
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.isEditMode = true;
      this.playerService.getById(Number(id)).subscribe(data => {
        this.player = data;
      });
    } else {
    }
  }

  savePlayer() {
    if (this.isEditMode) {
      this.playerService.update(this.player.id, this.player).subscribe(() => {
        this.router.navigate(['/players']);
      });
    } else {
      this.playerService.save(this.player).subscribe({
        next: () => this.router.navigate(['/players']),
        error: () => this._snackBar.open('Niet alle velden zijn correct gevuld.')
      });
    }
  }

  protected readonly Object = Object;
  protected readonly Strength = Strength;
}
